// All the below ids are gender neutral
export const forbiddenCombo = [
  {
    parentId: 'brazilian',
    childrenIds: ['bikini_line', 'perirectal'],
  },
  {
    parentId: 'full_back',
    childrenIds: ['half_back'],
  },
  {
    parentId: 'chest',
    childrenIds: ['areolas_and_sternum'],
  },
  {
    parentId: 'abdomen',
    childrenIds: ['navel'],
  },
  {
    parentId: 'upper_legs',
    childrenIds: ['upper_posterior_leg', 'upper_medial_leg'],
  },
];

// Also any combinable parent with any of its children is considered a forbidden combination
export const combinable = [
  {
    parentId: 'hands_and_fingers',
    childrenIds: ['hands', 'fingers'],
  },
  {
    parentId: 'feet_and_toes',
    childrenIds: ['feet', 'toes'],
  },
  {
    parentId: 'full_legs',
    childrenIds: ['lower_legs', 'upper_legs'],
  },
  {
    parentId: 'full_arms',
    childrenIds: ['forearms', 'upper_arms'],
  },
  {
    parentId: 'brazilian_plus',
    childrenIds: ['brazilian', 'buttocks'],
  },
  {
    parentId: 'areolas_and_sternum',
    childrenIds: ['areolas_only', 'sternum_only'],
  },

  {
    parentId: 'chest_abdomen',
    childrenIds: ['abdomen', 'chest'],
  },
  {
    parentId: 'full_face_and_neck',
    childrenIds: [
      'unibrow',
      'upper_lip',
      'chin',
      'cheeks',
      'neck',
      'sideburns',
      'jawline',
      'upper_cheek',
    ],
  },
  {
    parentId: 'back_t_shirt',
    childrenIds: ['full_back', 'upper_arms', 'shoulder'],
  },
  {
    parentId: 'front_t_shirt',
    childrenIds: ['chest_abdomen', 'upper_arms', 'shoulder'],
  },
  {
    parentId: 'full_t_shirt',
    childrenIds: ['front_t_shirt', 'back_t_shirt'],
  },
];

export const allParentsIds = Array.from(
  new Set([
    ...forbiddenCombo.map((elem) => elem.parentId),
    ...combinable.map((elem) => elem.parentId),
  ])
);
// Get children ids
export const combinableIds = combinable.map((obj) => obj.childrenIds).flat();
export const allCombos = [...forbiddenCombo, ...combinable];
// const forbiddenChildrenIds = Array.from(
//   new Set(forbiddenCombo.map((obj) => obj.childrenIds).flat())
// );
// export const allChildrenIds = [...combinableIds, ...forbiddenChildrenIds];
